"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgCamera(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M33.125 10.375h-4.694L27.5 8.726c-.5-.994-1.084-1.297-1.875-1.297h-11.25c-.79 0-1.376.303-1.875 1.297l-.931 1.649H6.875C5.843 10.375 5 11.554 5 12.48v16.836C5 30.241 5.843 31 6.875 31h26.25C34.157 31 35 30.241 35 29.316V12.48c0-.926-.843-2.105-1.875-2.105z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M20 15.429c-2.76 0-5 2.24-5 4.999 0 2.76 2.24 5 5 5s5-2.24 5-5c0-2.759-2.24-5-5-5z", stroke: "currentColor", strokeWidth: 2 }, void 0)] }), void 0));
}
exports.default = SvgCamera;
//# sourceMappingURL=Camera.js.map